module.exports = __webpack_public_path__ + "img/2.c8d1fb85.png";